import { Course, MenuBook } from '../../models';
import GenreRow from '../GenreRow';
import SubGenreRowList from '../SubGenreRowList';

export interface GenreRowListProps {
  menuBook: MenuBook;
  course?: Course;
}

function GenreRowList({ menuBook, course }: GenreRowListProps) {
  if (course) {
    return (
      <>
        {course.genres.map((genre) => (
          <GenreRow key={`genre-${genre.id}`} menuBook={menuBook} course={course} genre={genre}>
            <SubGenreRowList menuBook={menuBook} course={course} genre={genre} />
          </GenreRow>
        ))}
      </>
    );
  }

  return (
    <>
      {menuBook.genres &&
        menuBook.genres.map((genre) => (
          <GenreRow key={`genre-${genre.id}`} menuBook={menuBook} genre={genre}>
            <SubGenreRowList menuBook={menuBook} genre={genre} />
          </GenreRow>
        ))}
    </>
  );
}

export default GenreRowList;
